<div class="operator-bg" style="overflow-x:auto; padding:38px;">

	<!-- Alert pills (supervisor + breakdown) -->
	<div *ngIf="supervisorMachines.length > 0 || breakdownMachines.length > 0" style="padding: 8px 21px 15px; display:flex; flex-wrap:wrap; gap:10px;">
		<div *ngFor="let m of supervisorMachines" class="supervisor-pill supervisor-pill--amber blink_pulse">
			<i class="fas fa-bell" style="margin-right:10px;"></i>
			SUPERVISOR REQUIRED — <strong>{{m.cellNumber}}</strong>
		</div>
		<div *ngFor="let m of breakdownMachines" class="supervisor-pill supervisor-pill--red blink_pulse">
			<i class="fas fa-exclamation-triangle" style="margin-right:10px;"></i>
			BREAKDOWN — <strong>{{m.cellNumber}}</strong>
		</div>
	</div>

	<!-- Machines WITH running jobs -->
	<div class="row">
		<div *ngFor="let machine of pagedMachines" class="col-6 g-10">
			<div class="ms-card" [style.background-color]="renderStatusColor(machine.productionStatus)">

				<!-- Card header: cell + operator -->
				<div style="display:flex; align-items:center; justify-content:space-between; margin-bottom:30px;">
					<h3 style="color:white; font-size:2.344rem; font-weight:700; margin:0; background-color: #4b5563; padding-left:19px; padding-right:19px; border-radius:10px">{{machine.cellNumber}}</h3>
					<span *ngIf="machine.runningStages[0]?.assignedUserProfileId" style="font-size:1.64rem; font-weight:500; color:#ffffff; background-color: #4b5563; padding-left:19px; padding-right:19px; border-radius:10px">{{machine.runningStages[0]?.assignedUserProfileFullName}}</span>
					<span *ngIf="!machine.runningStages[0]?.assignedUserProfileId" class="blink_pulse" style="font-size:1.64rem; font-weight:500; color:#f87171; background-color: #4b5563; padding-left:19px; padding-right:19px; border-radius:10px">No Operator</span>
				</div>

				<!-- Current Work Order box -->
				<div *ngIf="machine.runningStages.length > 0" class="ms-wo-box">
					<div style="display:flex; align-items:flex-start; gap:30px;">
						<div class="ms-img-lg">
							<img [src]="machine.runningStages[0].partImage" alt="Part">
						</div>
						<div style="flex:1; min-width:0;">
							<p style="color:white; font-size:1.64rem; font-weight:500; margin:0 0 0px 0; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">{{machine.runningStages[0].partNumber}}</p>
							<p style="color:#d1d5db; font-size:1.64rem; margin:0 0 2px 0; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">WO-{{machine.runningStages[0].workOrderId}} &middot; Op: {{machine.runningStages[0].operationNumber}}</p>
							<p style="color:#9ca3af; font-size:1.4rem; margin:0 0 15px 0; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">

								<span style="color:#ffffff;">Qty:</span>
								<span style="color:white; font-weight:500; margin-left:4px;">{{machine.runningStages[0].quantityCompleted}} / {{machine.runningStages[0].quantityRequired}}</span>
								 | {{machine.runningStages[0].clientName}}
							</p>

						</div>
					</div>
					<!-- Progress bar -->
					<div style="margin-top:8px; height:8px; background-color:#4b5563; border-radius:99px; overflow:hidden;">
						<div [style.width]="getProgressWidth(machine.runningStages[0])"
							[style.background-color]="renderStatusColor(machine.productionStatus)"
							style="height:100%; border-radius:99px; min-width:2px; transition:width 0.3s ease;"></div>
					</div>
				</div>

				<div *ngIf="machine.runningStages.length == 0" class="ms-wo-box">
					<div style="display:flex; align-items:flex-start; gap:30px;">
						<div class="ms-img-lg ms-img-empty"></div>
						<div style="flex:1; min-width:0;">
							<p style="color:white; font-size:1.64rem; font-weight:500; margin:0 0 0px 0; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">Inactive.</p>
							<p style="color:#d1d5db; font-size:1.64rem; margin:0 0 2px 0; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;"></p>
							<p style="color:#9ca3af; font-size:1.4rem; margin:0 0 15px 0; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
								<span style="color:#ffffff;"></span>
								<span style="color:white; font-weight:500; margin-left:4px;"></span>
							</p>
						</div>
					</div>
					<!-- Progress bar -->
					<div style="margin-top:8px; height:8px; background-color:#4b5563; border-radius:99px; overflow:hidden;"></div>
				</div>

				<!-- Always 3 next job tiles -->
				<div style="margin-top:auto;">
					<h4 style="font-size:1.64rem; font-weight:500; color:#ffffff; margin:0 0 19px 0;">Next Jobs</h4>
					<div style="display:flex; flex-direction:column; gap:15px;">
						<ng-container *ngFor="let stage of getNextJobsPadded(machine)">

							<!-- Real job tile -->
							<div *ngIf="stage" class="ms-next-item">
								<div class="ms-img-sm"><img [src]="stage.partImage" alt="Part"></div>
								<div style="flex:1; min-width:0;">
									<p style="color:white; font-size:1.4rem; font-weight:500; margin:0 0 1px 0; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">{{stage.partNumber}}</p>
									<p style="color:white; font-size:1.313rem; margin:0; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">Op: {{stage.operationNumber}} &middot; {{stage.clientName}} &middot; Qty: {{stage.quantityRequired}}</p>
								</div>
							</div>

							<!-- Empty slot tile -->
							<div *ngIf="!stage" class="ms-next-item ms-next-empty">
								<div class="ms-img-sm ms-img-empty"></div>
								<p style="color:#ffffff; font-size:1.4rem; margin:0; font-style:italic;">No Job Queued</p>
							</div>

						</ng-container>
					</div>
				</div>

			</div>
		</div>
	</div>

	<!-- Page indicator -->
	<div *ngIf="totalPages > 1" class="ms-page-indicator">
		<span *ngFor="let p of [].constructor(totalPages); let i = index" class="ms-page-dot" [class.ms-page-dot--active]="i === pageIndex"></span>
		<span class="ms-page-label">Page {{pageIndex + 1}} of {{totalPages}}</span>
	</div>

</div>
